import { FACEBOOK_PAGE_ID, USER_ROOT_API_URL  } from "../../../../config/settings"

export const GET_INSTAGRAM_ACCESS_TOKEN = USER_ROOT_API_URL + "/get_instagram_access_token"
export const GET_INSTAGRAM_FEED = "me/media"
export const GET_FACEBOOK_PAGE = FACEBOOK_PAGE_ID
export const GET_FACEBOOK_FEED = FACEBOOK_PAGE_ID + "/feed"
export const GET_FACEBOOK_ACCESS_TOKEN = USER_ROOT_API_URL + "/get_facebook_access_token"
